function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M96.338 72c-3.294-.091-6.602-.097-9.894-.292-20.827-1.24-39.018-8.91-54.578-22.953-6.791-6.132-12.422-13.198-17.037-21.112-.347-.598-.746-1.154-1.285-1.993-2.819 5.492-5.539 10.78-8.523 16.594C3.25 36.643 1.612 31.54.048 26.415c-.14-.451.05-1.094.272-1.55C4.496 16.62 8.702 8.401 12.99 0c.776.343 1.473.598 2.138.949 7.27 3.768 14.556 7.497 21.769 11.382 1.004.545 1.974 1.703 2.352 2.797 1.646 4.66 3.063 9.4 4.713 14.548-3.596-1.85-6.786-3.49-10.11-5.188 3.028 10.587 26.998 26.45 45.952 29.104 33.028 4.623 57.829-8.773 75.354-37.308 4.816 2.558 9.766 5.182 14.842 7.883-5.715 10.65-12.936 19.765-22.097 27.296-11.812 9.72-25.134 16.146-40.171 18.839-3.02.54-6.054 1.023-9.085 1.535-.76.06-1.54.112-2.31.163z",
  fill: "#005646"
});

function SvgSmile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgSmile;